import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const OrderSettingsPageContent = lazy(() => import("./OrderSettingsPageContent"));

function OrderSettingsPageInternal() {
    return (
        <DefaultPage>
            <OrderSettingsPageContent />
        </DefaultPage>
    );
}

export const OrderSettingsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    OrderSettingsPageInternal
);
